export default function Error({ error }) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            color: 'var(--red)',
            backgroundColor: 'var(--black50)',
            margin: 10,
            padding: "5px 15px",
            borderRadius: 10,
            borderWidth: 2,
            borderColor: 'var(--red)',
            borderStyle: 'solid'
        }}>
            <h4 style={{ fontWeight: "bold" }}>Error:</h4>
            <p>{error.message}</p>
        </div>
    )
}